<section id="reports">
  <div class="divide70"></div>
  <div class="assan-features">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="center-heading">
            <h2>Reportes</h2>
            <span class="center-line"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-6 margin20">
          <div
            class="services-box wow animated fadeIn"
            data-wow-duration="700ms"
            data-wow-delay="100ms"
          >
            <div class="services-box-icon">
              <mat-icon>wallet</mat-icon>
            </div>
            <!--services icon-->
            <div class="services-box-info">
              <h4>Corte Diario</h4>
              <p>Registra Ingresos/Egresos del día</p>
            </div>
          </div>
          <!--services box-->
        </div>
        <!--services col-->
        <div class="col-md-4 col-sm-6 margin20">
          <div
            class="services-box wow animated fadeIn"
            data-wow-duration="700ms"
            data-wow-delay="200ms"
          >
            <div class="services-box-icon">
              <mat-icon>paid</mat-icon>
            </div>
            <!--services icon-->
            <div class="services-box-info">
              <h4>Ingreso / Egreso por día</h4>
              <p>Concentrado de los <b>ingresos y egresos</b> por día</p>
            </div>
          </div>
          <!--services box-->
        </div>
        <!--services col-->
        <div class="col-md-4 col-sm-6 margin20">
          <div
            class="services-box wow animated fadeIn"
            data-wow-duration="700ms"
            data-wow-delay="300ms"
          >
            <div class="services-box-icon">
              <mat-icon>request_quote</mat-icon>
            </div>
            <!--services icon-->
            <div class="services-box-info">
              <h4>Flujo de efectivo</h4>
              <p>Visualiza los <b>movimientos de efectivo</b> durante un periodo.</p>
            </div>
          </div>
          <!--services box-->
        </div>
        <!--services col-->

        <div class="col-md-4 col-sm-6 margin20">
          <div
            class="services-box wow animated fadeIn"
            data-wow-duration="700ms"
            data-wow-delay="400ms"
          >
            <div class="services-box-icon">
              <mat-icon>compare_arrows</mat-icon>
            </div>
            <!--services icon-->
            <div class="services-box-info">
              <h4>Comparativos</h4>
              <p>Visualiza y compara <b>varios meses o periodos</b> por categoria</p>
            </div>
          </div>
          <!--services box-->
        </div>
        <!--services col-->
        <div class="col-md-4 col-sm-6 margin20">
          <div
            class="services-box wow animated fadeIn"
            data-wow-duration="700ms"
            data-wow-delay="500ms"
          >
            <div class="services-box-icon">
              <mat-icon>calendar_today</mat-icon>
            </div>
            <!--services icon-->
            <div class="services-box-info">
              <h4>Reporte Mensual</h4>
              <p>Concentra los <b>ingresos y egresos</b> del mes seleccionado</p>
            </div>
          </div>
          <!--services box-->
        </div>
        <!--services col-->
      </div>
      <!--services row-->
    </div>
  </div>
  <!--assan features-->
</section>
